import React, { useState } from "react";
import { Table, Pagination, Card, } from "react-bootstrap";
import { RiLineChartFill, RiTeamFill, RiNodeTree } from "react-icons/ri";
import { Link } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

const summaryCards = [
  {
    title: "ROI Income",
    accent: "#8adaf0",
    accentBg: "rgba(0, 200, 255, 0.08)",
    icon: <RiLineChartFill />,
    rows: [
      { label: "Today", value: "0 records (₹ 0.00)", color: "#2563eb" },
      { label: "Yesterday", value: "0 records (₹ 0.00)", color: "#2563eb" },
      { label: "This Week", value: "0 records (₹ 0.00)", color: "#f59e0b" },
      { label: "This Month", value: "0 records (₹ 0.00)", color: "#ef4444" },
      { label: "All Time", value: "0 records (₹ 0.00)", color: "#02152f" },
    ],
  },
  {
    title: "Referral Income",
    accent: "#8adaf0",
    accentBg: "rgba(0, 200, 255, 0.08)",
    icon: <RiTeamFill />,
    rows: [
      { label: "Today", value: "0 records (₹0.00)", color: "#0aad6b" },
      { label: "Yesterday", value: "0 records (₹0.00)", color: "#0aad6b" },
      { label: "This Week", value: "0 records (₹0.00)", color: "#f59e0b" },
      { label: "This Month", value: "0 records (₹0.00)", color: "#ef4444" },
      { label: "All Time", value: "0 records (₹0.00)", color: "#02152f" },
    ],
  },
  {
    title: "Binary Income",
    accent: "#8adaf0",
    accentBg: "rgba(0, 200, 255, 0.08)",
    icon: <RiNodeTree />,
    rows: [
      { label: "Today", value: "0 records (₹0.00)", color: "#f59e0b" },
      { label: "Yesterday", value: "0 records (₹0.00)", color: "#f59e0b" },
      { label: "This Week", value: "0 records (₹0.00)", color: "#f59e0b" },
      { label: "This Month", value: "0 records (₹0.00)", color: "#ef4444" },
      { label: "All Time", value: "0 records (₹0.00)", color: "#02152f" },
    ],
  },
];

const tableData = [

  { id: 1, userId: "USR1001", amount: "₹120.00", type: "ROI Income", date: "04-06-2026" },
  { id: 2, userId: "USR1002", amount: "₹85.50", type: "Referral Income", date: "04-06-2026" },
  { id: 3, userId: "USR1003", amount: "₹200.00", type: "Binary Income", date: "03-06-2026" },
  { id: 4, userId: "USR1004", amount: "₹60.00", type: "ROI Income", date: "03-06-2026" },
  { id: 5, userId: "USR1005", amount: "₹45.00", type: "Referral Income", date: "02-06-2026" },
  { id: 6, userId: "USR1006", amount: "₹310.00", type: "Binary Income", date: "02-06-2026" },
  { id: 7, userId: "USR1007", amount: "₹90.00", type: "ROI Income", date: "01-06-2026" },

];

const typeColors = {
  "ROI Income": { bg: "rgba(37,99,235,0.09)", border: "rgba(37,99,235,0.22)", color: "#1d4ed8" },
  "Referral Income": { bg: "rgba(10,173,107,0.09)", border: "rgba(10,173,107,0.22)", color: "#0aad6b" },
  "Binary Income": { bg: "rgba(245,158,11,0.09)", border: "rgba(245,158,11,0.22)", color: "#d97706" },
};

export default function AdminIncomeReports() {

  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);

  const [perPage, setPerPage] = useState(10);

  const filtered = tableData.filter(

    (r) =>
      r.userId.toLowerCase().includes(search.toLowerCase()) ||
      r.type.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / perPage) || 1;

  const paginated = filtered.slice((page - 1) * perPage, page * perPage);


  const handleSearch = (e) => { setSearch(e.target.value); setPage(1); };

  const handlePerPage = (e) => { setPerPage(Number(e.target.value)); setPage(1); };

  return (
    <>

      <div className="breadcrumb-bar mb-2 mx-1" >
        <div className="container-fluid">
          <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

            <div className="breadcrumb-left d-flex align-items-center flex-wrap my-2">
              <Link to="/admin/home" className="breadcrumb-link active ">
                Home
              </Link>

              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>

              <span
                className="breadcrumb-link inactive"
              // onClick={() => navigate("/admin/ucky-draw")}
              >
                Total income reports
              </span>

            </div>

            {/* <button
              className="add-outlet-btn"
              onClick={() => navigate("/admin/add-luckydraw")}
            >

              Add LuckyDraw
            </button> */}

          </div>
        </div>
      </div>

      <div className="ir-root mx-3">
        <div className="ir-summary-grid">

          {summaryCards.map((card) => (

            <div className="ir-card" key={card.title} style={{ "--card-accent": card.accent, "--card-accent-bg": card.accentBg }}>

              <div className="ir-card-header">

                <div className="d-flex justify-content-between align-items-center">
                  <span className="fw-semibold text-dark">{card.title}</span>

                  <span
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "42px",
                      height: "42px",
                      background:
                        "linear-gradient(135deg, rgba(0,200,255,0.18), rgba(40, 65, 158, 0.25))",
                      border: "1px solid rgba(0,200,255,0.35)",
                      color: "#07a3ca",
                      fontSize: "1.2rem",
                      flexShrink: 0,
                    }}
                  >
                    {card.icon}
                  </span>
                </div>

              </div>

              <div className="ir-card-body">

                {card.rows.map((row) => (

                  <div className="ir-card-row" key={row.label}>

                    <span className="ir-row-label">{row.label}</span>
                    <span className="ir-row-value" style={{ color: row.color }}>{row.value}</span>

                  </div>
                ))}

              </div>
            </div>
          ))}
        </div>

        <div className="ir-table-section my-2">
          <div className="ir-table-controls">
            <div className="d-flex align-items-center gap-2">

              <span className="small text-muted">Show</span>

              <select className="ir-select" value={perPage} onChange={handlePerPage}>

                {[10, 25, 50, 100].map((v) => <option key={v} value={v}>{v}</option>)}

              </select>
              <span className="small text-muted">entries</span>
            </div>
            <div className="ir-search-wrap my-2">
              <span className="px-2 d-flex align-items-center">
                <FiSearch size={16} color="#6f7d92" />
              </span>
              <input
                className="ir-search-input"
                placeholder="Search..."
                value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>

        {/* table ---- >  */}

        <Card className="ud-table-card ">

          <Card.Body className="p-0">

            <div className="ud-scroll-wrap">

              <Table
                hover
                borderless
                className="ud-table align-middle mb-0"
              >

                <thead>

                  <tr>
                    <th>Sr No</th>
                    <th>User Id</th>
                    <th>Amount (₹)</th>
                    <th>Income Type</th>
                    <th>Date</th>
                  </tr>

                </thead>

                <tbody>

                  {paginated.length > 0 ? (

                    paginated.map((row) => {

                      const tc = typeColors[row.type] || {};

                      return (

                        <tr key={row.id}>

                          <td>{row.id}</td>

                          <td><span className="ir-userid">{row.userId}</span></td>

                          <td><span className="ir-amount">{row.amount}</span></td>

                          <td>
                            <span className="ir-type-badge" style={{ background: tc.bg, border: `1px solid ₹{tc.border}`, color: tc.color }}>
                              {row.type}
                            </span>
                          </td>

                          <td>{row.date}</td>

                        </tr>

                      );

                    })

                  ) : (

                    <tr>

                      <td colSpan={5} className="ir-empty">No data available in table</td>

                    </tr>

                  )}

                </tbody>

              </Table>

            </div>

          </Card.Body>

        </Card>

        <div className="ud-pagination-wrap">

          <Pagination className="ud-pagination mb-0">

            <Pagination.Prev
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            />

            {Array.from(
              { length: totalPages },
              (_, i) => i + 1
            ).map((p) => (

              <Pagination.Item
                key={p}
                active={page === p}
                onClick={() => setPage(p)}
              >
                {p}
              </Pagination.Item>

            ))}

            <Pagination.Next
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            />

          </Pagination>

        </div>
      </div>
    </>
  );
}